import React, { useEffect, useState } from 'react';

import AnimatedButton from '../../AnimatedSavingBtn';

export default ({
  rst,
  trpls,
  classes,
  isNewNode,
  ancestorId,
  loadingTids,
  setLoadingTids,
  onRstTypeBtnClick,
  disableTrplEditing,
}) => {
  const [textWidth, setTextWidth] = useState(0);
  const [status, setStatus] = useState('success');

  useEffect(() => {
    if (!rst) return;

    const test = document.getElementById(rst.id);
    const width = (test.clientWidth + 1) + "px";
    setTextWidth(width);
  }, []);

  const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;

  const changeStatus = (newStatus) => {
    setStatus(newStatus);
  };

  const callbacks = {setLoadingTids, changeStatus};

  return (
    <div>
      {trpls.map((trpl, trplIndex) => {
        return (
          <div key={`${rst.title}.${trplIndex}`} className={`${classes.alignCenter} ${trplIndex === 0 ? '' : classes.mt5}`}>
            <AnimatedButton
              variant={status}
              width={textWidth}
              disabled={loadingTids.includes(0) || disableTrplEditing}
              loading={loadingTids.includes(rstId)}
              onClick={() => onRstTypeBtnClick(rst, isNewNode ? null : ancestorId, callbacks )}
            >
              <span id={rst.id}>{rst.btn_title || 'Do action'}</span>
            </AnimatedButton>
          </div>
        )
      })}
    </div>
  );
};
